module.exports = __webpack_public_path__ + "img/student.ae5c58d.svg";